export function toggleValueInSet<Value>(set: Set<Value>, value: Value) {
    const copy = new Set([...set]);
    if (copy.has(value)) {
        copy.delete(value);
    } else {
        copy.add(value);
    }
    return copy;
}

export const mergeSets = <Value>(
    set1: Set<Value>,
    set2: Set<Value>
): Set<Value> => new Set([...set1, ...set2]);

export function diffSets<Value>(
    set1: Set<Value>,
    set2: Set<Value>
): Set<Value> {
    const result = new Set(set1);
    set2.forEach((value) => result.delete(value));
    return result;
}
